import PropTypes from "prop-types";
import { URL } from "@myloc/myloc-utils";

const ExternalLink = ({ url, type = Type.URL, target, children, customCssClass }) => (
  <a href={type + (url instanceof URL ? url.toString : url)} target={target && target} className={customCssClass}>
    {children}
  </a>
);

export const Type = {
  URL: "",
  EMAIL: "mailto:",
  PHONE: "tel:",
};

export const Target = {
  SELF: "_self",
  NEW_TAB: "_blank",
  PARENT: "_parent: ",
  FULL: "_top: ",
};

ExternalLink.propTypes = {
  url: PropTypes.oneOfType([PropTypes.instanceOf(URL), PropTypes.string]),
  type: PropTypes.oneOf([Type.URL, Type.EMAIL, Type.PHONE]),
  target: PropTypes.oneOf([Target.SELF, Target.NEW_TAB, Target.PARENT, Target.FULL]),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  customCssClass: PropTypes.string,
};

export default ExternalLink;
